import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, plan: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.PLAN_DUPLICATE_REQUEST:
      return { ...INITIAL_STATE, loading: true, plan: null, error: null };
    case CONST.PLAN_DUPLICATE_SUCCESS:
      return { ...INITIAL_STATE, loading: false, plan: action.plan, error: null };
    case CONST.PLAN_DUPLICATE_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, plan: null };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, plan: null };
    default:
      return state;
  }
};
